import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.auth.EmailField', {
    placeholderText: 'Enter your email address',
    emailLabelText: 'Email',
});
